import { createUseStyles } from 'react-jss';


import colors from "../../utils/colors";
import Spinner from "../../images/spinner.svg";

var styles = {
  tableBody: function tableBody(props) {return {
      pointerEvents: props.loading && 'none',
      maxHeight: props.maxHeight || '70rem',
      minHeight: props.loading && '25rem',
      overflowY: props.loading ? 'hidden' : 'auto',
      display: 'block',
      width: '100%',
      position: 'relative',
      '&::-webkit-scrollbar-button': {
        backgroundColor: 'black'
      },
      '&::after': {
        content: '""',
        display: props.loading ? 'block' : 'none',
        backgroundColor: 'rgba(0,0,0,0.03)',
        backgroundImage: props.loading && "url(".concat(Spinner, ")"),
        backgroundSize: '12.5%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        position: 'absolute',
        bottom: 0,
        left: 0,
        height: '100%',
        width: '100%'
      }
    };},
  noDataFallbackRow: {
    borderBottom: ['0.1rem', 'solid', colors.neutral[200]],
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  noDataFallbackCell: {
    padding: {
      top: '2rem',
      bottom: '2rem'
    }
  }
};

var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map